import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Text, Flex} from '@spothero/ui';

import {
    timeBoxStyles,
    labelStyles,
    dateTimeContainerStyles,
} from '../date-time-details/DateTimeDetails';

const dateStyles = {
    fontSize: {base: 'lg', tablet: 'xl'},
    fontWeight: 'semibold',
    lineHeight: 1.4,
};

const MonthlyDateTimeDetails = ({starts, ends}) => {
    const startDate = useMemo(() => starts.format('dddd,\nMMMM D'), [starts]);
    const endDate = useMemo(() => ends.format('dddd,\nMMMM D'), [ends]);

    return (
        <Flex {...dateTimeContainerStyles}>
            <Flex {...timeBoxStyles}>
                <Text {...labelStyles}>Start Date</Text>
                <Text
                    whiteSpace="pre-line"
                    data-testid="monthly-start-date"
                    {...dateStyles}
                >
                    {startDate}
                </Text>
            </Flex>
            <Flex
                borderLeftWidth="1px"
                borderColor="gray.100"
                {...timeBoxStyles}
            >
                <Text {...labelStyles}>End Date</Text>

                <Text
                    whiteSpace="pre-line"
                    data-testid="monthly-end-date"
                    {...dateStyles}
                >
                    {endDate}
                </Text>
            </Flex>
        </Flex>
    );
};

MonthlyDateTimeDetails.propTypes = {
    starts: PropTypes.object.isRequired,
    ends: PropTypes.object.isRequired,
};

export default MonthlyDateTimeDetails;
